"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sensenet = void 0;
exports.sensenet = {
    Entity: {
        account: 'AccountId',
        index: 'u128',
        cid: 'Vec<u8>',
        created: 'BlockNumber',
        mutated: 'BlockNumber',
    },
    EntityProperty: {
        value: 'u64',
        mutated: 'BlockNumber',
    },
};
